export interface CatProduct {
  id: number;
  name: string;
  price: number;
  originalPrice: number;
  category: string;
  badge: string;
  sizes: string[];
  description: string;
  image: string;
  images?: string[];
  gender?: string;
  isBaggy?: boolean;
  outOfStock?: boolean;
  stockBreakdown?: Record<string, unknown>;
  stock?: number;
  colors?: {
    name: string;
    hex: string;
    price?: number;
    image?: string;
    images?: string[];
  }[];
  selectedColor?: {
    name: string;
    hex: string;
    price?: number;
  };
}

export const trackPantsProducts: CatProduct[] = [];
export const tShirtsProducts: CatProduct[] = [];
export const jeansProducts: CatProduct[] = [];
export const hoodiesProducts: CatProduct[] = [];
export const shortsProducts: CatProduct[] = [];

export const ALL_CATEGORY_PRODUCTS: Record<string, CatProduct[]> = {
  'Track Pants': trackPantsProducts,
  'T-Shirts': tShirtsProducts,
  'Jeans': jeansProducts,
  'Hoodies': hoodiesProducts,
  'Shorts': shortsProducts,
};

export const CATEGORY_DESCRIPTIONS: Record<string, string> = {
  'Track Pants': 'Premium Track Pants - Gym & Casual Wear',
  'T-Shirts': 'Branded T-Shirts - All Styles',
  'Jeans': 'Premium Jeans - Slim, Straight & More',
  'Hoodies': 'Cozy Hoodies - Zip & Pullover Styles',
  'Shorts': 'Comfortable Shorts - Sports & Casual',
};

// Supabase product type
export interface SupabaseProduct {
  id: string;
  name: string;
  category: string;
  price: number;
  original_price: number;
  description: string;
  sizes: string[];
  colors: {
    name: string;
    hex: string;
    price?: number;
    image?: string;
    images?: string[];
  }[];
  stock: number;
  stock_breakdown: Record<string, unknown>;
  brand: string;
  tags: string[];
  thumbnail: string;
  images: string[];
  status: 'pending' | 'approved' | 'rejected';
  listed_by_phone?: string;
  listed_by_email?: string;
  created_at: string;
  updated_at: string;
}

// Convert Supabase product to CatProduct format
export function convertSupabaseProduct(sp: SupabaseProduct): CatProduct {
  return {
    id: 90000 + Math.floor(Math.random() * 10000),
    name: sp.name,
    price: sp.price,
    originalPrice: sp.original_price || sp.price,
    category: sp.category,
    badge: 'NEW',
    sizes: sp.sizes?.length ? sp.sizes : ['S', 'M', 'L', 'XL'],
    description: sp.description,
    image: sp.thumbnail || sp.images?.[0] || '',
    images: sp.images,
    colors: sp.colors,
    stock: sp.stock,
    stockBreakdown: sp.stock_breakdown,
    outOfStock: sp.stock === 0 || sp.status !== 'approved',
  };
}
